import { __assign } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import { useAnalyticsEvents } from '@invitae/nucleobase-analytics';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';

var Link = function (_a) {
    var _b = _a.fields, text = _b.text, linkScheme = _b.linkScheme, analyticsEvents = _b.analyticsEvents, _c = _a.classes, classes = _c === void 0 ? {} : _c, rootElementProps = _a.rootElementProps;
    var analyticsProps = useAnalyticsEvents({ analyticsEvents: analyticsEvents });
    return (React.createElement(BaseNucleobaseComponent, { classes: { root: classes.link }, rootElementProps: __assign(__assign({}, rootElementProps), analyticsProps), source: linkScheme },
        React.createElement("span", { className: classNames(classes.linkText) }, text)));
};

export { Link, Link as default };
//# sourceMappingURL=Link.esm.js.map
